import React from "react";
import { PanelEditSubCategory } from "../../../UI/SubCategories/Edit/PanelEditSubCategory";

const EditSubCategory = () => {
  return (
    <div>
      <PanelEditSubCategory />
    </div>
  );
};

export default EditSubCategory;
